import "core-js/modules/es6.object.to-string";
import _objectSpread from "@babel/runtime/helpers/esm/objectSpread";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import "core-js/modules/es6.function.name";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.promise";
import "core-js/modules/es6.object.assign";
import "core-js/modules/es7.promise.finally";
import Vue from 'vue';
import Meta from 'vue-meta';
import { createRouter } from './router.js';
import NoSsr from './components/no-ssr.js';
import NuxtChild from './components/nuxt-child.js';
import NuxtError from '../layouts/error.vue';
import Nuxt from './components/nuxt.js';
import App from './App.js';
import { setContext, getLocation, getRouteData, normalizeError } from './utils';
import { createStore } from './store.js';
/* Plugins */

import nuxt_plugin_sentryserver_38ed2758 from 'nuxt_plugin_sentryserver_38ed2758'; // Source: ./sentry.server.js (mode: 'server')

import nuxt_plugin_sentryclient_59989460 from 'nuxt_plugin_sentryclient_59989460'; // Source: ./sentry.client.js (mode: 'client')

import nuxt_plugin_vuescrollto_50d25bf5 from 'nuxt_plugin_vuescrollto_50d25bf5'; // Source: ./vue-scrollto.js (mode: 'client')

import nuxt_plugin_cookieuniversalnuxt_50ae333c from 'nuxt_plugin_cookieuniversalnuxt_50ae333c'; // Source: ./cookie-universal-nuxt.js (mode: 'all')

import nuxt_plugin_nuxtcustomheadersmiddleware620fccba_7b0d2b77 from 'nuxt_plugin_nuxtcustomheadersmiddleware620fccba_7b0d2b77'; // Source: ./nuxt-custom-headers.middleware.620fccba.js (mode: 'all')

import nuxt_plugin_recaptcha_019a3ffa from 'nuxt_plugin_recaptcha_019a3ffa'; // Source: ./recaptcha.js (mode: 'all')

import nuxt_plugin_apollomodule_62be3360 from 'nuxt_plugin_apollomodule_62be3360'; // Source: ./apollo-module.js (mode: 'all')

import nuxt_plugin_axios_7f563b94 from 'nuxt_plugin_axios_7f563b94'; // Source: ./axios.js (mode: 'all')

import nuxt_plugin_webfontloader_6886a4d8 from 'nuxt_plugin_webfontloader_6886a4d8'; // Source: ./webfontloader.js (mode: 'client')

import nuxt_plugin_axios_3566aa80 from 'nuxt_plugin_axios_3566aa80'; // Source: ../plugins/axios (mode: 'all')

import nuxt_plugin_lazysizes_63bafee8 from 'nuxt_plugin_lazysizes_63bafee8'; // Source: ../plugins/lazysizes (mode: 'client')

import nuxt_plugin_vuecarousel_6c010c3d from 'nuxt_plugin_vuecarousel_6c010c3d'; // Source: ../plugins/vue-carousel (mode: 'client')

import nuxt_plugin_smoothscroll_68d9071e from 'nuxt_plugin_smoothscroll_68d9071e'; // Source: ../plugins/smoothscroll (mode: 'client')

import nuxt_plugin_vue2touchevents_0aa7791c from 'nuxt_plugin_vue2touchevents_0aa7791c'; // Source: ../plugins/vue2-touch-events (mode: 'client')

import nuxt_plugin_globalmixins_415d51c6 from 'nuxt_plugin_globalmixins_415d51c6'; // Source: ../plugins/global-mixins (mode: 'all')

import nuxt_plugin_mdmicon_d6dbc0b4 from 'nuxt_plugin_mdmicon_d6dbc0b4'; // Source: ../plugins/mdm-icon (mode: 'all')

import nuxt_plugin_vuei18n_9dc1c90a from 'nuxt_plugin_vuei18n_9dc1c90a'; // Source: ../plugins/vue-i18n (mode: 'all')
// Component: <NoSsr>

Vue.component(NoSsr.name, NoSsr); // Component: <NuxtChild>

Vue.component(NuxtChild.name, NuxtChild);
Vue.component('NChild', NuxtChild); // Component NuxtLink is imported in server.js or client.js
// Component: <Nuxt>`

Vue.component(Nuxt.name, Nuxt); // vue-meta configuration

Vue.use(Meta, {
  keyName: 'head',
  // the component option name that vue-meta looks for meta info on.
  attribute: 'data-n-head',
  // the attribute name vue-meta adds to the tags it observes
  ssrAttribute: 'data-n-head-ssr',
  // the attribute name that lets vue-meta know that meta info has already been server-rendered
  tagIDKeyName: 'hid' // the property name that vue-meta uses to determine whether to overwrite or append a tag

});
var defaultTransition = {
  "name": "page",
  "mode": "",
  "appear": false,
  "appearClass": "appear",
  "appearActiveClass": "appear-active",
  "appearToClass": "appear-to"
};

function createApp(_x) {
  return _createApp.apply(this, arguments);
}

function _createApp() {
  _createApp = _asyncToGenerator(
  /*#__PURE__*/
  regeneratorRuntime.mark(function _callee2(ssrContext) {
    var router, store, registerModule, app, next, route, path, inject;
    return regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            _context2.next = 2;
            return createRouter(ssrContext);

          case 2:
            router = _context2.sent;
            store = createStore(ssrContext); // Add this.$router into store actions/mutations

            store.$router = router; // Fix SSR caveat https://github.com/nuxt/nuxt.js/issues/3757#issuecomment-414689141

            registerModule = store.registerModule;

            store.registerModule = function (path, rawModule, options) {
              return registerModule.call(store, path, rawModule, Object.assign({
                preserveState: process.client
              }, options));
            }; // Create Root instance
            // here we inject the router and store to all child components,
            // making them available everywhere as `this.$router` and `this.$store`.


            app = _objectSpread({
              router: router,
              store: store,
              nuxt: {
                defaultTransition: defaultTransition,
                transitions: [defaultTransition],
                setTransitions: function setTransitions(transitions) {
                  if (!Array.isArray(transitions)) {
                    transitions = [transitions];
                  }

                  transitions = transitions.map(function (transition) {
                    if (!transition) {
                      transition = defaultTransition;
                    } else if (typeof transition === 'string') {
                      transition = Object.assign({}, defaultTransition, {
                        name: transition
                      });
                    } else {
                      transition = Object.assign({}, defaultTransition, transition);
                    }

                    return transition;
                  });
                  this.$options.nuxt.transitions = transitions;
                  return transitions;
                },
                err: null,
                dateErr: null,
                error: function error(err) {
                  err = err || null;
                  app.context._errored = Boolean(err);
                  err = err ? normalizeError(err) : null;
                  var nuxt = this.nuxt || this.$options.nuxt;
                  nuxt.dateErr = Date.now();
                  nuxt.err = err; // Used in src/server.js

                  if (ssrContext) ssrContext.nuxt.error = err;
                  return err;
                }
              }
            }, App); // Make app available into store via this.app

            store.app = app;
            next = ssrContext ? ssrContext.next : function (location) {
              return app.router.push(location);
            }; // Resolve route

            if (ssrContext) {
              route = router.resolve(ssrContext.url).route;
            } else {
              path = getLocation(router.options.base);
              route = router.resolve(path).route;
            } // Set context to app.context


            _context2.next = 13;
            return setContext(app, {
              route: route,
              next: next,
              error: app.nuxt.error.bind(app),
              store: store,
              payload: ssrContext ? ssrContext.payload : undefined,
              req: ssrContext ? ssrContext.req : undefined,
              res: ssrContext ? ssrContext.res : undefined,
              beforeRenderFns: ssrContext ? ssrContext.beforeRenderFns : undefined,
              ssrContext: ssrContext
            });

          case 13:
            inject = function inject(key, value) {
              if (!key) throw new Error('inject(key, value) has no key provided');
              if (typeof value === 'undefined') throw new Error('inject(key, value) has no value provided');
              key = '$' + key; // Add into app

              app[key] = value; // Add into store

              store[key] = app[key]; // Check if plugin not already installed

              var installKey = '__nuxt_' + key + '_installed__';
              if (Vue[installKey]) return;
              Vue[installKey] = true; // Call Vue.use() to install the plugin into vm

              Vue.use(function () {
                if (!Vue.prototype.hasOwnProperty(key)) {
                  Object.defineProperty(Vue.prototype, key, {
                    get: function get() {
                      return this.$root.$options[key];
                    }
                  });
                }
              });
            };

            if (process.client) {
              // Replace store state before plugins execution
              if (window.__NUXT__ && window.__NUXT__.state) {
                store.replaceState(window.__NUXT__.state);
              }
            } // Plugin execution


            if (!(process.server && typeof nuxt_plugin_sentryserver_38ed2758 === 'function')) {
              _context2.next = 18;
              break;
            }

            _context2.next = 18;
            return nuxt_plugin_sentryserver_38ed2758(app.context, inject);

          case 18:
            if (!(process.client && typeof nuxt_plugin_sentryclient_59989460 === 'function')) {
              _context2.next = 21;
              break;
            }

            _context2.next = 21;
            return nuxt_plugin_sentryclient_59989460(app.context, inject);

          case 21:
            if (!(process.client && typeof nuxt_plugin_vuescrollto_50d25bf5 === 'function')) {
              _context2.next = 24;
              break;
            }

            _context2.next = 24;
            return nuxt_plugin_vuescrollto_50d25bf5(app.context, inject);

          case 24:
            if (!(typeof nuxt_plugin_cookieuniversalnuxt_50ae333c === 'function')) {
              _context2.next = 27;
              break;
            }

            _context2.next = 27;
            return nuxt_plugin_cookieuniversalnuxt_50ae333c(app.context, inject);

          case 27:
            if (!(typeof nuxt_plugin_nuxtcustomheadersmiddleware620fccba_7b0d2b77 === 'function')) {
              _context2.next = 30;
              break;
            }

            _context2.next = 30;
            return nuxt_plugin_nuxtcustomheadersmiddleware620fccba_7b0d2b77(app.context, inject);

          case 30:
            if (!(typeof nuxt_plugin_recaptcha_019a3ffa === 'function')) {
              _context2.next = 33;
              break;
            }

            _context2.next = 33;
            return nuxt_plugin_recaptcha_019a3ffa(app.context, inject);

          case 33:
            if (!(typeof nuxt_plugin_apollomodule_62be3360 === 'function')) {
              _context2.next = 36;
              break;
            }

            _context2.next = 36;
            return nuxt_plugin_apollomodule_62be3360(app.context, inject);

          case 36:
            if (!(typeof nuxt_plugin_axios_7f563b94 === 'function')) {
              _context2.next = 39;
              break;
            }

            _context2.next = 39;
            return nuxt_plugin_axios_7f563b94(app.context, inject);

          case 39:
            if (!(process.client && typeof nuxt_plugin_webfontloader_6886a4d8 === 'function')) {
              _context2.next = 42;
              break;
            }

            _context2.next = 42;
            return nuxt_plugin_webfontloader_6886a4d8(app.context, inject);

          case 42:
            if (!(typeof nuxt_plugin_axios_3566aa80 === 'function')) {
              _context2.next = 45;
              break;
            }

            _context2.next = 45;
            return nuxt_plugin_axios_3566aa80(app.context, inject);

          case 45:
            if (!(process.client && typeof nuxt_plugin_lazysizes_63bafee8 === 'function')) {
              _context2.next = 48;
              break;
            }

            _context2.next = 48;
            return nuxt_plugin_lazysizes_63bafee8(app.context, inject);

          case 48:
            if (!(process.client && typeof nuxt_plugin_vuecarousel_6c010c3d === 'function')) {
              _context2.next = 51;
              break;
            }

            _context2.next = 51;
            return nuxt_plugin_vuecarousel_6c010c3d(app.context, inject);

          case 51:
            if (!(process.client && typeof nuxt_plugin_smoothscroll_68d9071e === 'function')) {
              _context2.next = 54;
              break;
            }

            _context2.next = 54;
            return nuxt_plugin_smoothscroll_68d9071e(app.context, inject);

          case 54:
            if (!(process.client && typeof nuxt_plugin_vue2touchevents_0aa7791c === 'function')) {
              _context2.next = 57;
              break;
            }

            _context2.next = 57;
            return nuxt_plugin_vue2touchevents_0aa7791c(app.context, inject);

          case 57:
            if (!(typeof nuxt_plugin_globalmixins_415d51c6 === 'function')) {
              _context2.next = 60;
              break;
            }

            _context2.next = 60;
            return nuxt_plugin_globalmixins_415d51c6(app.context, inject);

          case 60:
            if (!(typeof nuxt_plugin_mdmicon_d6dbc0b4 === 'function')) {
              _context2.next = 63;
              break;
            }

            _context2.next = 63;
            return nuxt_plugin_mdmicon_d6dbc0b4(app.context, inject);

          case 63:
            if (!(typeof nuxt_plugin_vuei18n_9dc1c90a === 'function')) {
              _context2.next = 66;
              break;
            }

            _context2.next = 66;
            return nuxt_plugin_vuei18n_9dc1c90a(app.context, inject);

          case 66:
            if (!(process.server && ssrContext && ssrContext.url)) {
              _context2.next = 69;
              break;
            }

            _context2.next = 69;
            return new Promise(function (resolve, reject) {
              router.push(ssrContext.url, resolve, function () {
                // navigated to a different route in router guard
                var unregister = router.afterEach(
                /*#__PURE__*/
                function () {
                  var _ref = _asyncToGenerator(
                  /*#__PURE__*/
                  regeneratorRuntime.mark(function _callee(to, from, next) {
                    return regeneratorRuntime.wrap(function _callee$(_context) {
                      while (1) {
                        switch (_context.prev = _context.next) {
                          case 0:
                            ssrContext.url = to.fullPath;
                            _context.next = 3;
                            return getRouteData(to);

                          case 3:
                            app.context.route = _context.sent;
                            app.context.params = to.params || {};
                            app.context.query = to.query || {};
                            unregister();
                            resolve();

                          case 8:
                          case "end":
                            return _context.stop();
                        }
                      }
                    }, _callee);
                  }));

                  return function (_x2, _x3, _x4) {
                    return _ref.apply(this, arguments);
                  };
                }());
              });
            });

          case 69:
            return _context2.abrupt("return", {
              app: app,
              store: store,
              router: router
            });

          case 70:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));
  return _createApp.apply(this, arguments);
}

export { createApp, NuxtError };